import React, { useEffect } from 'react';
import Head from 'next/head';
import { observer } from 'mobx-react';
import { useGlobalStore } from 'stores';
import { qtClient } from 'client/pc/lib';
import { browser } from 'lib';
import { GlobalStyle } from '@/client/widgets/ui/layout-frame';
import { ErrorBoundary } from '@components';
import assetsConfig from '@/lib/assets-config';
import ImApp from './im-app';
import useLayoutInit from './use-layout-init';

const PageBase = observer((props: any) => {
  const {
    children,
    pageClass = '',
    enableImApp = false,
    enableFontSize,
  } = props;
  const { setDark, setPageClass, setQtClientReady, isLogin } = useGlobalStore();

  useLayoutInit({ enableFontSize });

  useEffect(() => {
    setPageClass(`_dark  ${pageClass}`);
    setDark(true);
  }, [pageClass]);

  useEffect(() => {
    qtClient.init(() => {
      setQtClientReady(true);
    });
    if (!browser.memeClient) {
      setQtClientReady(true);
    }
    return () => {
      qtClient.destroy();
    };
  }, []);

  return (
    <>
      <Head>
        <title>么么直播</title>
        <meta
          content="么么直播,么么秀场,美女主播,美女视频,视频直播,美女秀场"
          name="keywords"
        />
        <meta
          content="么么直播，一个与真人美女主播在线视频聊天的交友社区，支持百万人同时在线视频聊天交友、K歌互动。"
          name="description"
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
          var inPcClient=true;
          `,
          }}
        ></script>
      </Head>
      <GlobalStyle></GlobalStyle>
      <ErrorBoundary from="imApp" hideTip>
        {enableImApp && isLogin && <ImApp></ImApp>}
      </ErrorBoundary>
      <ErrorBoundary from="clientLayout">{children}</ErrorBoundary>
    </>
  );
});

export default PageBase;
